import * as TypeGraphQL from "type-graphql";
export var SystemAlertStatus;
(function (SystemAlertStatus) {
    SystemAlertStatus["ACTIVE"] = "ACTIVE";
    SystemAlertStatus["ACKNOWLEDGED"] = "ACKNOWLEDGED";
    SystemAlertStatus["RESOLVED"] = "RESOLVED";
    SystemAlertStatus["SUPPRESSED"] = "SUPPRESSED";
})(SystemAlertStatus || (SystemAlertStatus = {}));
TypeGraphQL.registerEnumType(SystemAlertStatus, {
    name: "SystemAlertStatus",
    description: undefined,
});
//# sourceMappingURL=SystemAlertStatus.js.map